const En = {
  addStorageSystem: 'Add Storage System',
  arrayDiscovery: 'Discover Array',
  arrayDiscoveryExistEnv: 'Discover Array',
  arraySetup: 'Set Up Array',
  arraySetupExistEnv: 'Set Up Array',
  arraySetupForApp: 'Set Up Array',
  arraySetupdHCI: 'Set Up dHCI',
  arrayValidation: 'Validate Array',
  addAndAssignArray: 'Add and Assign Array',
  alletraMPB10k: 'HPE Alletra Storage MP B10000',
  baas: 'HPE GreenLake for Block Storage',
  back: 'Back',
  cable: 'Cable',
  cableBluetooth: 'Cable',
  cableSwitched: 'Cable',
  cableSimplivity: 'Cable',
  checklist: 'Checklist',
  cloudEnable: 'Connect Array',
  cloudenablement: 'Cloud Enablement',
  collapseAll: 'Collapse All',
  connectArray: 'Connect Array',
  connectArrayForApp: 'Connect Array',
  connectClusterForApp: 'Connect Cluster',
  connectClusterForCLI: 'Connect Cluster',
  configSwitch: 'Configure the switch',
  configSwitchExistEnv: 'Configure the switch',
  configVCenter: 'Configure vCenter',
  continue: 'Continue',
  ConfigureIloPort: 'Configure iLO Port',
  ConfigureIloPortSimplivity325Gen11: 'Configure iLO Port',
  ConfigureIloPortSimplivity380Gen11: 'Configure iLO Port',
  ConfigureIloPortSimplivity380: 'Configure iLO Port',
  ConnectToIlo: 'Connect to iLO',
  ConnectToIloSimplivity325Gen11: 'Connect to iLO',
  ConnectToIloSimplivity380Gen11: 'Connect to iLO',
  ConnectToIloSimplivity380: 'Connect to iLO',
  composingAWS: 'Composing',
  ConnectToVcenter: 'Connect vCenter',
  connectCluster: 'Connect Cluster',
  downloadDeploymentGuide: 'Download Deployment Guide',
  downloadDeploymentGuideSimplivity: 'Download Server Install Guide',
  downloadFullDoc: 'Download Full Documentation',
  downloadInstallGuide: 'Download Installation Guide',
  discoverCluster: 'Discover Cluster',
  errorSelectModel: 'Select array model to continue',
  environment: 'Environment',
  existingEnvironment: 'Existing Environment',
  existingEsxiCluster: 'Existing ESXi Cluster',
  expandAll: 'Expand All',
  errorSelectPurchase: 'Select Purchase to continue',
  errorSelectConnectionMethod: 'Select initialization method to continue',
  errorSelectConfigureMethod: 'Select configuration to continue',
  errorSelectInstallationType: 'Select installation type to continue',
  errorSelectSimplivityModel: 'Select Model type to continue',
  errorSelectHpeAlletraDHCIModel: 'Select environment to continue',
  file: 'HPE GreenLake for File Storage',
  finished: 'Finished',
  getStarted: "Let's get started",
  gettingStarted: 'Getting Started',
  hpeAlletra: 'HPE Alletra Storage',
  hpeAlletra6: 'HPE Alletra 6000 Storage Array',
  install: 'Install',
  installShelves: 'Install Shelves',
  initialize: 'Initialize',
  installConnectManager: 'Install Connection Manager',
  installBrackets: 'Install Brackets',
  installBracketsSimplivity325Gen11: 'Install Brackets',
  installBracketsSimplivity380: 'Install Brackets',
  installBracketsSimplivity380Plus: 'Install Brackets',
  installBracketsSimplivity380Gen11: 'Install Brackets',
  installServer: 'Install Server',
  installServerSimplivity325Gen11: 'Install Server',
  installServerSimplivity380: 'Install Server',
  installServerSimplivity380Plus: 'Install Server',
  installServerSimplivity380Gen11: 'Install Server',
  loading: 'Loading',
  logoAltText: 'HPE Nimble Storage Logo',
  linkingValidatingAWS: 'Linking and validating',
  model: 'Model',
  newEnvironment: 'New Environment',
  newEsxiCluster: 'New ESXi Cluster',
  nimbleStorageArray: 'HPE Nimble Storage',
  nimbleStoragedHCI: 'HPE Alletra dHCI Storage',
  oaas: 'HPE Alletra Storage MP X10000',
  physicalInstallation: 'Physical Installation',
  plsSendEmail: 'To send feedback on the information provided here, contact us at ',
  powerOn: 'Power On',
  powerOnSimplivity: 'Power On',
  powerOnSimplivity325Gen11: 'Power On',
  powerOnSimplivity380Gen11: 'Power On',
  powerOnSimplivity380: 'Power On',
  powerOnSimplivity380Plus: 'Power On',
  powerUp: 'Power Up',
  powerUpAndInit: 'Power Up and Initialize',
  preInstallation: 'Preinstallation',
  preAppInstallation: 'Preinstallation',
  preInstallationForCLI: 'Preinstallation',
  preInstallationSimplivity325: 'Preinstallation',
  preInstallationSimplivity325Gen11: 'Preinstallation',
  preInstallationSimplivity380: 'Preinstallation',
  preInstallationSimplivity380Plus: 'Preinstallation',
  preInstallationSimplivity380Gen11: 'Preinstallation',
  'preInstallation-brown': 'Preinstallation',
  'preInstallation-green': 'Preinstallation',
  preInstallationDesc1: 'When the array arrives, you will neeed a physical location that is suitable for the array.',
  preInstallationDesc2: 'Nimble recommends that this be a dedicated space with restricted access.',
  prepareClient: 'Prepare Client',
  prepareEnv: 'Prepare Environment',
  prepareEnvExistEnv: 'Prepare Environment',
  prerequisites: 'Prerequisites',
  primeraStorage: 'HPE Primera Storage',
  productSelection: 'Please select your product to continue',
  proStack: 'Prostack',
  privateCloudBusinessEdition: 'HPE GreenLake for Private Cloud Business Edition',
  planSwitched: 'Plan',
  planSwitchedNoCableTray: 'Plan',
  planDirectAttached: 'Plan',
  plan: 'Plan',
  rack: 'Rack',
  rackArray: 'Rack Array',
  rackSwitched: 'Rack',
  rackServersSwitches: 'Rack Servers & Switches',
  reachTechnicalSupport: 'To reach Technical Support for product related questions or issues, refer to the list of ',
  setup: 'Setup',
  setupArray: 'Set up Array',
  sendFeedback: 'Send Feedback',
  sendFeedbackDesc:
    'Do you have a question, suggestion, or concern about your Welcome Center experience? We value your opinion and would like to hear from you.',
  selectArrayModel: 'Select Array Model',
  selectArrayModelDesc: 'Please select the model you would like to install',
  selectStorageTier: 'Select Storage Type',
  selectArrayModelDescBaas: 'Storage Tier',
  selectArrayModelDescAlletraB10K: 'Model',
  selectArrayModelDescPrimera: 'Select the installation type',
  selectConnect: 'Initialization Method',
  selectConfiguration: 'Configuration',
  setupComplete: 'Setup Complete',
  setupConnectManager: 'SetUp Connection Manager',
  // configVCenterNewEnv: 'Configure vCenter for dHCI for a New Environment',
  // configVCenterExistEnv: 'Configure vCenter for dHCI for an Existing Environment',
  siteReadiness: 'Site Readiness',
  siteReadinessApp: 'Site Readiness',
  softwareConfig: 'Software Configuration',
  storagedPrimera: 'HPE Nimble Storage dHCI',
  softwareDefinedStorage: 'HPE Software Defined Storage',
  storageTier: 'Storage Tier',
  selectStoragePurchaseDesc: 'Select the storage purchase',
  selectStoragePurchase: 'Purchase Option',
  simpliVityModel: 'Model',
  simplivityModelOPT325Gen: '325 Gen10',
  simplivityModelOPT325GenPlusV2: '325 Gen10 Plus V2',
  simplivityModelOPT380Gen: '380 Gen10',
  simplivityModelOPT380GenPlus: '380 Gen10 Plus',
  simplivityModelOPT325Gen11: '325 Gen11',
  simplivityModelOPT380Gen11: '380 Gen11',
  setupCluster: 'Set up Cluster',
  setupClusterForApp: 'Set up Cluster',
  selectArrayModelDescInstallationType: 'Installation Type',
  selectCableTray: 'Cable Tray',
  takeSurvey: 'Take Survey',
  unbox: 'Unbox',
  unboxField: 'Unbox',
  unboxFactory: 'Unbox',
  unpack: 'Unpack',
  welcomeCenter: 'Welcome Center',
};
export default En;
